module.exports = __webpack_public_path__ + "static/media/family.449f3033.svg";